import { go, some } from 'fxjs/es';

export const SAMSUNG_BP_ID = 6949;
export const hasSamsungBp = (user_products) => {
  return go(
    user_products,
    some(({ base_product_id }) => base_product_id == SAMSUNG_BP_ID),
  );
};
